<template>
  <div class="outer-wrapper">
    <nav class="breadcrumbs">
      <ul class="breadcrumbs__list">
        <li class="breadcrumbs__list-item">
          <router-link :to="parentUrl">{{ parentTitle }}</router-link>
        </li>
        <li class="breadcrumbs__list-item">
          <span>/</span> {{ currentTitle }}
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
export default {
  name: 'Breadcrumbs',
  props: {
    currentTitle: {
      type: String,
      required: true
    },
    parentTitle: {
      type: String,
      required: true
    },
    parentUrl: {
      type: String,
      required: true
    }
  }
}
</script>

<style lang="postcss" scoped>
@import '../variables/custom-media.css';

.outer-wrapper {
  display: flex;
  justify-content: center;
  max-width: var(--spacing-max-width-large);
  margin: 0 auto;
}

.breadcrumbs {
  display: flex;
  width: 100%;
  padding: var(--spacing) 0 0;
  margin: 0 var(--spacing);

  @media (--bp-nis-medium) {
    margin: 0;
  }

  & .breadcrumbs__list {
    display: flex;

    & .breadcrumbs__list-item {
      margin-left: var(--spacing-half);

      & span {
        margin-right: var(--spacing-third);
      }
    }

    & .breadcrumbs__list-item:first-of-type {
      margin: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Breadcrumbs.vue